import MuiTableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';

const StyledTableHeaderRow = styled(MuiTableRow, {
    shouldForwardProp: prop => !['scrollbarWidth', 'height', 'width', 'rtl', 'columnResizingShift'].includes(prop),
}) `
  ${({ scrollbarWidth, height, width, rtl }) => `
    margin: ${rtl ? `0 0 0 ${scrollbarWidth || 0}px` : `0 ${scrollbarWidth || 0}px 0 0`};
    color: unset;
    border: none;
    height: ${`${height}px` || 'fit-content'};
    width: ${width ? `${width - (scrollbarWidth || 0) + 1}px` : 'fit-content'};
    display: flex;
    direction: ${rtl ? 'rtl' : 'ltr'};
    border: solid 1px transparent;
    overflow: auto;
  `}
`;

export { StyledTableHeaderRow as default };
//# sourceMappingURL=StyledTableHeaderRow.js.map
